import * as _4 from 'lodash4';
import { RegistrationReceiptQuery } from '../../queries/registration_receipt_query';
import { ClearRegistrationRecieptCommand } from '../../commands/clear_registration_reciept_command';
import { RequestActionServant } from '../../../views/registration_transactions/servants/request_action_servant';

class RegistrationReceipt {
  constructor(
    private clearRegistrationRecieptCommand: ClearRegistrationRecieptCommand,
    private ngRegistrationReceiptQuery: RegistrationReceiptQuery,
    private ngRequestActionServant: RequestActionServant
  ) {}

  closeRegistrationReceipt() {
    this.clearRegistrationRecieptCommand();
  }

  $onDestroy() {
    this.closeRegistrationReceipt();
  }
}

angular.module('capability-ng-scheduler').component('registrationReceipt', {
  templateUrl:
    'capability-ng-scheduler/src/registration_receipt/components/registration_receipt/registration_receipt.html',
  controller: RegistrationReceipt
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_receipt/components/registration_receipt/registration_receipt.ts